// extracted by mini-css-extract-plugin
module.exports = {"LoginDetailsButtons":"NostrLogin_LoginDetailsButtons__3HrUX","LoginInfoFooter":"NostrLogin_LoginInfoFooter__yYErI"};